/* import __COLOCATED_TEMPLATE__ from './filters.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { select } from '@banking/ui/services/reporter';
import { computed } from '@ember/object';
import { feature } from '@square/ember-features/macros';
import { inject as service } from '@ember/service';
import { canAccessStatements } from '@banking/ui/utils/country-permissions';
import { isExportDisabled, CARD_SPEND_CATEGORY } from '@banking/ui/workflows/unified-activity/unified-activity';
let ActivityFilters = (_dec = select(isExportDisabled), _dec2 = feature('banking/enable_card_filter'), _dec3 = computed('args.typeCategories.length'), _dec4 = computed('args.cardCategories.length'), _class = class ActivityFilters extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isExportDisabled", _descriptor, this);
    _initializerDefineProperty(this, "enableCardFilter", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
  }
  get canAccessStatements() {
    return canAccessStatements(this.userInfo);
  }
  get hasTypeCategories() {
    return this.args.typeCategories.length > 0;
  }
  get hasCardCategories() {
    return this.args.cardCategories && this.args.cardCategories.length > 1;
  }

  // Card filter only shows when feature flag is on and "Card spend" type is selected
  get showCardFilter() {
    return this.enableCardFilter && this.hasCardCategories && this.args.selectedTypeCategory === CARD_SPEND_CATEGORY;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isExportDisabled", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "enableCardFilter", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasTypeCategories", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "hasTypeCategories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCardCategories", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "hasCardCategories"), _class.prototype), _class);
export { ActivityFilters as default };